import { PlayerAvailabilityDto, PlayerAvailabilityResponse } from '@/infrastructure/network/dto/playerAvailabilityDto';

export const mapToPlayerAvailabilityDto = (data: PlayerAvailabilityResponse): PlayerAvailabilityDto[] => {
	return data.results.teamLeagueTeamPlayersAvailabilities.map((item) => ({
		uuid: item.uuid,
		playerUuid: item.playerUuid,
		dayOfWeek: item.dayOfWeek,
		timeSlot: item.timeSlot,
		teamUuid: item.teamUuid
	}));
};
